import { render, staticRenderFns } from "./SpringSaleHero.vue?vue&type=template&id=4663f2bb&"
import script from "./SpringSaleHero.vue?vue&type=script&lang=js&"
export * from "./SpringSaleHero.vue?vue&type=script&lang=js&"
import style0 from "./SpringSaleHero.vue?vue&type=style&index=0&id=4663f2bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartCountdownAltAuto: require('/opt/build/repo/components/Cart/CountdownAltAuto.vue').default})
